export const cardRatio = 0.7191;
export const cardCornerRadiusRatio = 0.09;
export const maxCardCornerRadius = 18;
export const cardGap = {
  desktop: { vertical: 14, horizontal: 14 },
  mobile: { vertical: 10, horizontal: 10 },
};
export const cardMaximisationStep = 2; // px
